import React, { Suspense } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'

import Footer from './components/footer/Footer'
import SkeletonLoader from './components/loaders/SkeletonLoader'
import { authSelector } from './redux/authSlice/authSlice'
import authRoute from './routes/authRoute'
import userRoute from './routes/userRoute'
// import GuestLogin from './screens/authScreen/GuestLogin'
import { useAppSelector } from './store/hooks'
import AddToCartPage from './screens/userScreen/AddToCartPage'
import MyQuotesPage from './screens/userScreen/MyQuotesPage'
interface ValidateRouteProps {
  element: React.ReactNode
  isAuthenticated: boolean
  fallbackPath?: string
}

const ValidateRoute: React.FC<ValidateRouteProps> = ({ element, fallbackPath = '/login' }) => {
  const isGuestLoggedIn = localStorage.getItem("user") !== null;
  const { isLoggedIn } = useAppSelector(authSelector);
  const isAuthenticated = isLoggedIn || isGuestLoggedIn;

  if (!React.isValidElement(element)) return null;

  return isAuthenticated ? element : <Navigate to={fallbackPath} replace />;
};


function App(): JSX.Element {
  const { isLoggedIn } = useAppSelector(authSelector)

  const isAuthenticated: boolean = isLoggedIn

 const location = useLocation();

const hideFooterRoutes = [
  '/login',
  '/signup',
  '/resetPassword'
];

const hideFooter = hideFooterRoutes.includes(location.pathname);

  return (
    <Suspense fallback={<SkeletonLoader />} >
      <div className="pb-16 lg:pb-0">
        <Routes>
          {/* auth route */}
          <Route path="/login" element={<authRoute.Login />} />
          <Route path="/signup" element={<authRoute.SignUp />} />
          <Route path="/resetPassword" element={<authRoute.ResetPassword />} />
          <Route path="*" element={<userRoute.PageNotFound />} />
          <Route path="/" element={<userRoute.Home />} />
          <Route path="/cart" element={<AddToCartPage />} />
          <Route path="/myQuotes" element={<MyQuotesPage />} />


          {/* <Route path="/guest-login" element={<GuestLogin />} /> */}

          {/* secured route */}
          <Route path="/package" element={<ValidateRoute element={<userRoute.Package />} isAuthenticated={isAuthenticated} />} />
          <Route path="/membership" element={<ValidateRoute element={<userRoute.MemberShip />} isAuthenticated={isAuthenticated} />} />
          <Route path="/ListOfServiceBookings" element={<ValidateRoute element={<userRoute.ListOfServiceBookings />} isAuthenticated={isAuthenticated} />} />
          <Route path="/account" element={<ValidateRoute element={<userRoute.Account />} isAuthenticated={isAuthenticated} />} />
          <Route path="/addVehicle" element={<ValidateRoute element={<userRoute.AddVehicle />} isAuthenticated={isAuthenticated} />} />
          <Route path="/vehicle/:category" element={<ValidateRoute element={<userRoute.Vehicle />} isAuthenticated={isAuthenticated} />} />
          <Route path="/serviceBooking" element={<ValidateRoute element={<userRoute.ServiceBooking />} isAuthenticated={isAuthenticated} />} />
          <Route path="/orders" element={<ValidateRoute element={<userRoute.Orders />} isAuthenticated={isAuthenticated} />} />
          <Route path="/vehicles" element={<ValidateRoute element={<userRoute.MyVehicles />} isAuthenticated={isAuthenticated} />} />
          <Route path="/vehicles/:vehicleId" element={<ValidateRoute element={<userRoute.VehicleDetails />} isAuthenticated={isAuthenticated} />} />
          <Route path="/rentVehicle" element={<ValidateRoute element={<userRoute.RentVehicle />} isAuthenticated={isAuthenticated} />} />
          <Route path="/profile" element={<ValidateRoute element={<userRoute.Profile />} isAuthenticated={isAuthenticated} />} />
        </Routes>
      </div>

    {!hideFooter && (
  <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden">
    <Footer />
  </div>
  )}
    </Suspense>
  )
}

export default App
